<template>
  <main class="page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="运营商名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px"
              v-model="filter.platformName"
              :fetch-suggestions="$_handleSearchPlatform"
              :trigger-on-focus="false"
              value-key="platformName"
              @select="$_handleSelectPlatform"
            ></el-autocomplete>
            <div
              v-show="!searchPlatformData.length && filter.platformName"
              @click="$_clearSearchPlatformData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该运营商，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="品牌名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              style="width: 110px"
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该品牌，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="餐品名称:">
          <el-input
            v-model="filter.productName"
            style="width: 110px"
          ></el-input>
        </el-form-item>

        <el-form-item label="餐品ID:">
          <el-input v-model="filter.pid" style="width: 110px"></el-input>
        </el-form-item>

        <el-form-item label="供应商名称:">
          <el-input
            v-model="filter.supplierName"
            style="width: 110px"
          ></el-input>
        </el-form-item>

        <el-form-item label="订阅名称:">
          <el-input
            v-model="filter.supplierSubscribeName"
            style="width: 110px"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="120" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_open(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          :formatter="column.formatter"
        ></el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getMealsList"
      ></cd-pagination>
    </div>
    <!-- 查看弹窗 -->
    <meals-dialog
      :visible.sync="dialog.visible"
      :data.sync="dialog.data"
    ></meals-dialog>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import mealsDialog from "./dialog.vue";
import resize from "@/mixins/resize";
const columns = [
  { key: "dataSources", label: "数据来源", width: 120 },
  { key: "platformName", label: "运营商", width: 120 },
  { key: "brandName", label: "品牌名称", width: 120 },
  { key: "name", label: "餐品名称", width: 120 },
  { key: "pid", label: "餐品ID", width: 160 },
  { key: "supplierName", label: "供应商名称", width: 160 },
  { key: "supplierSubscribeName", label: "订阅名称", width: 160 },
  { key: "subPid", label: "映射ID", width: 160 },
  { key: "mappingName", label: "映射名称", width: 160 },
  { key: "creator", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 },
  { key: "note", label: "备注" },
];
export default {
  name: "map-meals",
  mixins: [resize],
  components: {
    mealsDialog,
  },
  data() {
    return {
      isLoading: false,
      filter: {},
      searchPlatformData: [],
      searchBrandData: [],
      tableHeight: null,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        total: 0,
      },
      dialog: {
        visible: false,
        data: {},
      },
    };
  },
  mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getMealsList();
  },
  methods: {
    // 下拉联想运营商
    $_handleSearchPlatform(platformName, cb) {
      let postData = {
        platformName: platformName,
        pageNow: 1,
        pageSize: 9999,
      };
      this.$service.post("getPlatformList", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchPlatformData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择运营商
    $_handleSelectPlatform(item) {
      this.filter.platformName = item.platformName;
    },
    $_clearSearchPlatformData() {
      this.filter.platformName = "";
    },
    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999,
      };
      this.$service.post("getBrands", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchBrandData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if (this.filter.shopId && new RegExp(reg).test(this.filter.shopId)) {
        $MessageBox.alert({
          content: `
            <div>中台门店id需填数字！</div>
          `,
        });
      } else if (
        this.filter.brandId &&
        new RegExp(reg).test(this.filter.brandId)
      ) {
        $MessageBox.alert({
          content: `
            <div>系统品牌id需填数字！</div>
          `,
        });
      } else {
        this.$_getMealsList();
      }
    },
    // 重置
    $_reset() {
      this.filter = {};
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getMealsList();
    },
    // 查询餐品列表
    async $_getMealsList() {
      this.isLoading = true;
      try {
        this.$refs.tableList.clearSort();
        const pageParamsObj = {
          pageNow: this.pagination.pageNow,
          pageSize: this.pagination.pageSize,
        };
        const postData = Object.assign({}, this.filter, pageParamsObj);
        await this.$service.post("getMapMealsList", postData).then((result) => {
          if (result.$.checkResult(result, true)) {
            this.pagination.total = result.data.total;
            const rowsList = result.data.rows;
            const dataList = rowsList.map(item => {
              const productInfo = item.productInfo
              return {
                ...item,
                ...productInfo
              }
            })
            this.dataList = dataList
          }
        });
      } catch {
      } finally {
        this.isLoading = false;
      }
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getMealsList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getMealsList();
    },
    $_open(row) {
      this.dialog.data = JSON.parse(JSON.stringify(row));
      this.dialog.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .filter-form {
    .autocomplete-box {
      display: inline-block;
      position: relative;

      .autocomplete-empty {
        padding: 10px;
        margin: 0;
        color: #535353;
        width: 100%;
      }
    }
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
</style>